module.exports = __webpack_public_path__ + "static/media/revesdiab.c2b017a7.jpg";